// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar_Avatar__t3BEC","avatarBackground":"Avatar_avatarBackground__O-BxV"};